module.exports = __webpack_public_path__ + "static/img/h4-2.63cb17f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/aboutUs/h4-2.png
// module id = HEYU
// module chunks = 1